import React from 'react';
import PropTypes from 'prop-types';

import {
  searchContainerSection,
  searchResetSection,
  searchErrorStyles,
} from 'constants/styles';
import Button from 'components/Button';
import MapboxGeocoder from 'components/MapboxGeocoder';

class SearchComponent extends React.Component {
  renderLocationNearbyMessageSection() {
    if (this.props.locationNearby) {
      return;
    }

    return (
      <div
        className="searchErrors"
        id="searchErrorsMessage"
        style={searchErrorStyles}
      >
        We couldn't find any locations in your area. Please try another search.
      </div>
    );
  }

  renderButtonSection() {
    const { handleManualSearch, handleClear } = this.props;

    return (
      <div style={searchResetSection}>
        <Button
          type="button"
          handleClick={handleManualSearch}
          aria-label="Search Location"
          label="Search"
          addTopMargin
        />

        <button
          onClick={handleClear}
          className="link-button"
          aria-label="View all locations on Map"
          type="button"
        >
          View All
        </button>
      </div>
    );
  }
  render() {
    const { isSearchUsable } = this.props;

    return (
      <div className="searchContainer" style={searchContainerSection}>
        <MapboxGeocoder isSearchUsable={isSearchUsable} />
        {isSearchUsable && (
          <React.Fragment>
            {this.renderButtonSection()}
            {this.renderLocationNearbyMessageSection()}
          </React.Fragment>
        )}
      </div>
    );
  }
}

SearchComponent.propTypes = {
  handleClear: PropTypes.func.isRequired,
  handleManualSearch: PropTypes.func.isRequired,
  locationNearby: PropTypes.bool.isRequired,
  isSearchUsable: PropTypes.bool.isRequired,
};

export default SearchComponent;
